import { render, staticRenderFns } from "./GroupSubscriptionsEditing.vue?vue&type=template&id=b5a2b548"
import script from "./GroupSubscriptionsEditing.vue?vue&type=script&lang=js"
export * from "./GroupSubscriptionsEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports